import moment from 'moment';
import React from 'react';
import { constants } from '../../../../Helpers/Constants';
import Button from '../Button';
import colours from '../Colours';
import Icon from '../Icons/Icon';
import { CaptionMedium, CaptionSmall, P3, P3Bold, P4 } from '../Text';

const ReminderStatusCard = (props) => {
    let activated = props.activated;

    let data = {
        container: {
            activated: 'ds-statuscard-container-red',
            none: 'ds-statuscard-container-lightgrey',
        },
        header: {
            activated: 'ds-statuscard-header-red',
            none: 'ds-statuscard-header-lightgrey',
        },
        headerText: {
            activated: "ACTIVATED REMINDER:",
            none: "NO REMINDERS",
        },
        headerButton: {
            activated: null,
            none: <div style={{height: 24}}></div>,
        },
        renderContent: {
            activated: <ActivatedContent data={activated}/>,
            none: null,
        }
    }

    let type = 'none';

    //determine status card type with the following check:
    if (props.activated) {
        type = 'activated';
    } 

    return (
        <div className={data.container[type]}>
            <div className={"ds-statuscard-header " + data.header[type]}>
                <P3Bold style={{color: (type == 'request') ? colours.primary.grey01 : colours.primary.white}}>
                    {data.headerText[type]}
                </P3Bold>
                {data.headerButton[type]}
            </div>
            {data.renderContent[type]}
        </div>
        )
}

const ActivatedContent = ({data}) => {

    return (
        <div className="ds-statuscard-content">
            <div className="ds-statuscard-content-row-space-between mt-4">
                <P3Bold style={{color: colours.primary.grey01}}>{data.category}</P3Bold> 
                {data.remind_date ? <P3Bold style={{color: colours.primary.grey01}}>{moment(data.remind_date).format('MMM DD, YYYY')}</P3Bold>
                    : data.remind_km ? <P3Bold style={{color: colours.primary.grey01}}>{new Intl.NumberFormat().format(data.remind_km)} KM</P3Bold> 
                    : null }
            </div>
            <div className="ds-statuscard-button-row-centered">
                <Button secondary small label="Move to Completed" onClick={()=> {}}/>
            </div>
        </div>
    )
}

export default ReminderStatusCard;